import { Card, Chip, IconButton } from '@mui/material'
import React from 'react'
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isPresentInFavorites } from '../config/log';
import { addToFavorite } from '../State/Authentication/Action';

const RestaurantCard = ({item}) => {
    const navigate=useNavigate();
    const dispatch=useDispatch();
    const jwt=localStorage.getItem("jwt");
    const {auth} =useSelector(store=>store);

    const handleAddToFavorite=()=>{
        dispatch(addToFavorite({restaurantId:item.id,jwt}))
    }
    const handleNavigateToRestaurant=()=>{
        // if(item.open){
        //     navigate(`/restaurant/${item.address.city}/${item.name}/${item.id}`)
        // }
        navigate("/restaurant/:city/:title/:id")

    }
  return (
    <Card className=' w-[18rem]'>
        <div className={`${true?'cursor-pointer':"cursor-not-allowed"} relative`}>
                <img
                className='w-full h-[10rem] rounded-t-md object-cover' 
                src= "https://images.pexels.com/photos/5865071/pexels-photo-5865071.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                // {item.images[0]}
                />
                
                <Chip 
                size='small'
                className='absolute top-2 left-2'
                color={item.open?"success":"error"}
                label={item.open?"Open":"Closed"}
                />

                
        </div>
        <div className='p-4 textPart lg:flex w-full justify-between'>
            <div className='space-y-1'>
                <p onClick={handleNavigateToRestaurant} className='font-semibold text-lg cursor-pointer'> 
                     {/* {item.name} */}
                     Indian Fast Food
                </p>
                <p className='text-gray-500 text-sm'>
                    {/* {item.description} */}
                    Craving it all ? Drive into our Traditional Indian taste food.
                 </p>
            </div>
        <div>
            <IconButton onClick={handleAddToFavorite}>
                {isPresentInFavorites(auth.favorites,item)?<FavoriteIcon/>:<FavoriteBorderIcon/>}
            </IconButton>
        </div>
        </div>

    </Card>
  )
}

export default RestaurantCard